import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface NewsItem {
  title: string;
  link: string;
  source: string;
  publishedAt: string;
  summary: string;
}

export function useLorcanaNews() {
  return useQuery({
    queryKey: ['lorcana-news'],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke('lorcana-news');
      if (error) throw error;
      return (data?.items || []) as NewsItem[];
    },
    staleTime: 60 * 60 * 1000, // 1 hour
    refetchInterval: 60 * 60 * 1000, // refresh hourly while mounted
    refetchOnWindowFocus: false,
  });
}
